// Keep browser submission behavior independent of modal and AJAX details.
export function bindContactFormSubmission(form, button, submit, onError, onFinally) {
    if (!form || !button) return;
    let pending = false;
    form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (pending) return;
        pending = true;
        button.disabled = true;
        try {
            await submit(event);
        } catch (error) {
            await onError(error);
        } finally {
            pending = false;
            button.disabled = false;
            onFinally();
        }
    });
}

const THANK_YOU_ATTRIBUTION_PARAMS = [
    'utm_id', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
    'utm_source_platform', 'utm_creative_format', 'utm_marketing_tactic',
    'gclid', 'gbraid', 'wbraid', 'gad_source', 'gad_campaignid', 'campaignid',
    'adgroupid', 'creative', 'keyword', 'matchtype', 'network', 'device', 'placement',
];

export function contactThankYouURL(search) {
    const incoming = new URLSearchParams(search);
    const filtered = new URLSearchParams();
    for (const name of THANK_YOU_ATTRIBUTION_PARAMS) {
        const value = incoming.get(name);
        if (value && value.length <= 512) filtered.set(name, value);
    }
    const query = filtered.toString();
    return `/zonidirect/index-typ.html${query ? '?' + query : ''}`;
}
